import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["input", "list"]

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      draggable: ".sortable-list__item",
      animation: 150,
      onEnd: this.updateOrder
    })

    this.updateOrder()
  }

  updateOrder = () => {
    const names = Array.from(this.sortable.el.children).map(el => el.dataset.name)
    this.inputTarget.value = names.join(",")
  }
}